import React from "react";
import { Handle, Position } from "reactflow";
import { GraphLayoutDirection, NodeType } from "src/constants/selfServe/executionViewConstants";
import "src/components/selfServeWorkflows/executionView/execution-view.scss";

export default function TerminalNode({ data }) {
  const handleClick = (event) => {
    event.stopPropagation();
  } 
  const targetHandlePosition = data.alignment == GraphLayoutDirection.TopToBottom? Position.Top : Position.Left;
  const sourceHandlePosition = data.alignment == GraphLayoutDirection.TopToBottom? Position.Bottom : Position.Right;
  return (
    <>
      {data.type === NodeType.END && (
        <Handle type="target" position={targetHandlePosition} />
      )}
      <div className={`terminal-node ${data.type ?? ""}`} onClick={handleClick}>{data.type}</div>
      {data.type === NodeType.START && (
        <Handle type="source" position={sourceHandlePosition} />
      )}
    </>
  );
}
